import axios from 'axios';
import { API_URL } from '../config/api';

/**
 * Soumettre une notation
 */
export const submitRating = async (rating, comment, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/ratings`,
      {
        rating,
        comment: comment || null
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur lors de la soumission de votre avis' };
  }
};

/**
 * Récupérer les notations de l'utilisateur connecté
 */
export const getUserRatings = async (token, limit = 50) => {
  try {
    const response = await axios.get(
      `${API_URL}/ratings?limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur lors de la récupération de vos avis' };
  }
};

/**
 * Récupérer les statistiques globales
 */
export const getStats = async () => {
  try {
    const response = await axios.get(`${API_URL}/ratings/stats`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur lors de la récupération des statistiques' };
  }
};
